/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';
import { AbstractSchemaInhCommand } from './AbstractSchemaInhCommand';

/**
 * A command used to add a child schema to the
 * @author eric.wittmann@gmail.com
 * @extends AbstractSchemaInhCommand
 * @class
 */
export class AddChildSchemaCommand extends AbstractSchemaInhCommand {
    public _schemaPath : NodePath;

    public _newChildSchemaType : string;

    public _newChildSchemaObj : any;

    public _nullChildList : boolean;

    public _childIndex : number;

    public constructor(schema? : any, childSchema? : any, childType? : any) {
        if(((schema != null && schema instanceof <any>OasSchema) || schema === null) && ((childSchema != null && childSchema instanceof <any>OasSchema) || childSchema === null) && ((typeof childType === 'string') || childType === null)) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._newChildSchemaType===undefined) this._newChildSchemaType = null;
            if(this._newChildSchemaObj===undefined) this._newChildSchemaObj = null;
            if(this._nullChildList===undefined) this._nullChildList = false;
            if(this._childIndex===undefined) this._childIndex = 0;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._newChildSchemaType===undefined) this._newChildSchemaType = null;
            if(this._newChildSchemaObj===undefined) this._newChildSchemaObj = null;
            if(this._nullChildList===undefined) this._nullChildList = false;
            if(this._childIndex===undefined) this._childIndex = 0;
            (() => {
                this._schemaPath = Library.createNodePath(schema);
                this._newChildSchemaObj = Library.writeNode(childSchema);
                this._newChildSchemaType = childType;
            })();
        } else if(schema === undefined && childSchema === undefined && childType === undefined) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._newChildSchemaType===undefined) this._newChildSchemaType = null;
            if(this._newChildSchemaObj===undefined) this._newChildSchemaObj = null;
            if(this._nullChildList===undefined) this._nullChildList = false;
            if(this._childIndex===undefined) this._childIndex = 0;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._newChildSchemaType===undefined) this._newChildSchemaType = null;
            if(this._newChildSchemaObj===undefined) this._newChildSchemaObj = null;
            if(this._nullChildList===undefined) this._nullChildList = false;
            if(this._childIndex===undefined) this._childIndex = 0;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddChildSchemaCommand] Executing.");
        this._nullChildList = false;
        this._childIndex = -1;
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        let schemas : Array<OasSchema> = null;
        let newSchema : OasSchema = null;
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ALL_OF, this._newChildSchemaType)) {
            schemas = schema.allOf;
            newSchema = schema.createAllOfSchema();
            Library.readNode(this._newChildSchemaObj, newSchema);
            schema.addAllOfSchema(newSchema);
            this._childIndex = /* size */(<number>schema.allOf.length) - 1;
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ANY_OF, this._newChildSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            schemas = schema30.anyOf;
            newSchema = (<Oas30Schema>schema).createAnyOfSchema();
            Library.readNode(this._newChildSchemaObj, newSchema);
            (<Oas30Schema>schema).addAnyOfSchema(<Oas30Schema.Oas30AnyOfSchema>newSchema);
            this._childIndex = /* size */(<number>(<Oas30Schema>schema).anyOf.length) - 1;
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ONE_OF, this._newChildSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            schemas = schema30.oneOf;
            newSchema = (<Oas30Schema>schema).createOneOfSchema();
            Library.readNode(this._newChildSchemaObj, newSchema);
            (<Oas30Schema>schema).addOneOfSchema(<Oas30Schema.Oas30OneOfSchema>newSchema);
            this._childIndex = /* size */(<number>(<Oas30Schema>schema).oneOf.length) - 1;
        }
        if(schemas == null) {
            this._nullChildList = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddChildSchemaCommand] Reverting.");
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema) || this._childIndex === -1) {
            return;
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ALL_OF, this._newChildSchemaType)) {
            if(this._nullChildList) {
                schema.allOf = null;
            } else {
                /* remove */schema.allOf.splice(this._childIndex, 1)[0];
            }
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ANY_OF, this._newChildSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            if(this._nullChildList) {
                schema30.anyOf = null;
            } else {
                /* remove */schema30.anyOf.splice(this._childIndex, 1)[0];
            }
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ONE_OF, this._newChildSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            if(this._nullChildList) {
                schema30.oneOf = null;
            } else {
                /* remove */schema30.oneOf.splice(this._childIndex, 1)[0];
            }
        }
    }
}
AddChildSchemaCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddChildSchemaCommand";
AddChildSchemaCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

